"use client";

import Player from "./player";

interface TryDemoProps {
  inferenceUrl: string;
}

const TryDemo = ({ inferenceUrl }: TryDemoProps) => {
  return (
    <div className="relative mt-12 flex w-full justify-center px-4">
      <Player inferenceUrl={inferenceUrl} />
    </div>
  );
};

export default TryDemo;
